import React from 'react'
import {Request} from '../main'

import {Image} from 'react-bootstrap'
import {JoinCommunity} from './Block'
import Link from 'next/link'
import { isDomain } from '../utils/general'

const request = new Request(process.env.apiDomain)

function CommunityNav(props) {
    const site = props.site
    const {data: hub} = request.website.swrSite(site.accountId, "HUB")
    const {data: profile} = request.account.swrAccountProfile(site.accountId);
    const {data: shaklee} = request.account.swrShakleeInfo(site.accountId, profile ? profile.user.id : profile);

    const hubDomain = hub ? (isDomain(hub.url) ? 'www.'+hub.url : hub.url) : '';

    return (
        <>
            <JoinCommunity/>

            {hub ? 
                <Link href={"https://" + hubDomain}><a className="mb-3 d-md-block d-flex p-3 align-items-center">
                    <p className="mb-0 order-md-1 order-2">Visit my Hubsite</p>
                    <Image width={45} src="/images/sections/img-visit-my-hubsite.svg" className="mr-md-0 mr-2"/>
                </a></Link>
            : null}

            {shaklee && shaklee.shaklee_pws_name ? 
                <>
                    <Link href={"https://pws.shaklee.com/" + shaklee.shaklee_pws_name }><a className="d-md-block d-flex p-3 align-items-center">
                        <p className="mb-0 order-md-1 order-2">Visit my Wellness Shop</p>
                        <Image width={45} src="/images/sections/img-visit-my-wellness-shop-01.svg" className="mr-md-0 mr-2"/>
                    </a></Link>
                </>
            : null}
        
        </>
    )
}

export default CommunityNav
